import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Item No.', 'ITEMNO', true, 'asc', 'left'),
  new TableColumn('Description', 'ITEMDESC', true, 'asc', 'left'),
  new TableColumn('Type', 'ITEMTYPE', true, 'asc', 'centered'),
  new TableColumn('Is Custom', 'ISCUSTOM', true, 'desc', 'centered'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export { Columns }
